// Stable diagnostic codes, not source-message text, are the translation keys.
// Codes are API contracts: changing copy must not change a code.
export const diagnosticCatalog: Record<string, readonly [string,string]> = {
 "PUBLISH_DATABASE_CREDENTIAL_INPUT_INVALID": ["请检查数据库凭据、证书及配置绑定；TiDB API key 必须成对提供。", "Check database credentials, certificates and configuration binding; TiDB API keys must be supplied as a pair."],
 "PUBLISH_MYSQL_CONFIGURATION_INVALID": ["请检查 MySQL 内网主机、端口和管理账号，并移除 TiDB 绑定。", "Check the private MySQL host, port and provisioning account, and remove TiDB bindings."],
 "PUBLISH_MYSQL_CREDENTIAL_MATCH": ["MySQL 凭据需与草稿主机、端口和管理账号一致，安装前验证 TLS 和登录。", "MySQL credentials must match the draft host, port and provisioning account; TLS and login are verified before installation."],
  "DEVELOPMENT_DATABASE_UNAVAILABLE": ["Sandbox 开发数据库管理暂不可用，请检查管理连接并刷新状态。", "Sandbox development database management is unavailable. Check the management connection and refresh."],
  "DEVELOPMENT_DATABASE_STORAGE_UNAVAILABLE": ["开发数据库加密存储不可用，请检查加密密钥和迁移状态。", "Development database encrypted storage is unavailable. Check the encryption key and migrations."],
  "DEVELOPMENT_DATABASE_INPUT_INVALID": ["请检查成对的 API 公私钥、实例 ID、密码、容量、保留期和操作原因。", "Check the API key pair, instance ID, password, capacity, retention, and operation reason."],
  "DEVELOPMENT_DATABASE_REVISION_CONFLICT": ["配置或绑定已被修改，请清空输入并刷新后重试。", "The configuration or binding changed. Clear inputs and refresh before retrying."],
  "DEVELOPMENT_DATABASE_BUSY": ["开发数据库操作正在进行，请稍后刷新状态。", "A development database operation is running. Refresh shortly."],
  "DEVELOPMENT_DATABASE_NOT_CONFIGURED": ["请先配置 API 公私钥、共享开发实例 ID 和 root 密码。", "Configure the API key pair, shared development instance ID, and root password first."],
  "DEVELOPMENT_DATABASE_POOL_IN_USE": ["还有未释放的开发库，不能切换共享实例或连接方式。", "Development databases still exist. Release them before switching the shared instance or endpoint mode."],
  "DEVELOPMENT_DATABASE_CONNECTION_FAILED": ["TiDB Cloud 或 SQL 连接检查失败，请核对凭据、实例及数据中心网络。", "TiDB Cloud or SQL connection validation failed. Check credentials, instance, and data center networking."],
  "DEVELOPMENT_DATABASE_CAPACITY_EXHAUSTED": ["开发数据库数量已达到上限，请释放闲置数据库或调整容量。", "The development database limit is reached. Release unused databases or adjust capacity."],
  "DEVELOPMENT_DATABASE_IN_USE": ["仍有运行实例、任务或环境准备使用这个工作区，不能释放开发库。", "A runtime, task, or environment preparation still uses this workspace. Its development database cannot be released."],
  "DEVELOPMENT_DATABASE_BINDING_INVALID": ["开发数据库归属信息不匹配，操作已拒绝。", "Development database ownership does not match. The operation was rejected."],
  "DEVELOPMENT_DATABASE_GRANT_CONFLICT": ["开发数据库账号权限与绑定不一致，已停止操作。", "Database account grants do not match the binding. The operation was stopped."],
  "DEVELOPMENT_DATABASE_PROVISION_FAILED": ["开发数据库创建未完成，记录已保留，可重试或等待到期清理。", "Database provisioning did not complete. Its record is retained for retry or expiry cleanup."],
  "DEVELOPMENT_DATABASE_RELEASE_FAILED": ["开发数据库释放未完成，后台会根据保留的记录继续清理。", "Database release did not complete. Background reconciliation will resume cleanup from the retained record."],
  "DEVELOPMENT_DATABASE_FORBIDDEN": ["当前身份无权管理开发数据库接入。", "This identity cannot manage development database access."],
  "OPERATION_AUDIT_FAILED": ["组件操作已完成，但审计更新失败。请刷新配置及操作记录。", "The component completed the operation, but the audit update failed. Refresh configuration and operations."],
  "PLATFORM_SERVICES_OUTCOME_PENDING": ["操作结果待确认，请刷新人工操作记录，勿重复提交。", "The operation outcome is pending. Refresh operation history; do not submit again."],
  "PLATFORM_SERVICES_REJECTED": ["组件拒绝操作，请刷新配置，并核对字段、凭据及当前版本。", "The component rejected the operation. Refresh configuration and check fields, credentials, and revision."],
  "PLATFORM_SERVICES_UNAVAILABLE": ["平台服务不可用，请检查管理连接。", "Platform services are unavailable. Check the management connection."],
  "PLATFORM_SERVICES_NOT_CONFIGURED": ["平台服务管理连接尚未配置，请检查数据中心平台服务接线。", "Platform services management is not configured. Check the data center connection."],
  "WEB_SEARCH_NOT_CONFIGURED": ["尚未配置联网搜索密钥，请在联网搜索页面填写 Tavily API Key。", "Web search has no API key. Configure a Tavily API key on the Web search page."],
  "WEB_SEARCH_DISABLED": ["联网搜索已停用，请启用后保存。", "Web search is disabled. Enable it and save."],
  "WEB_SEARCH_AUTH_FAILED": ["Tavily 认证失败，请检查 API Key 是否有效或已被撤销。", "Tavily authentication failed. Check whether the API key is valid or has been revoked."],
  "WEB_SEARCH_RATE_LIMITED": ["Tavily 请求频率受限，请稍后重试。", "Tavily rate limit reached. Try again later."],
  "WEB_SEARCH_QUOTA_EXCEEDED": ["Tavily 用量已达到额度上限，请检查账户额度。", "Tavily usage limit reached. Check your account quota."],
  "WEB_SEARCH_TIMEOUT": ["连接 Tavily 超时，请检查数据中心网络或增加超时时间。", "Tavily timed out. Check the data center network or increase the timeout."],
  "WEB_SEARCH_NETWORK_FAILED": ["无法连接 Tavily，请检查数据中心的 DNS、证书与外网访问。", "Cannot connect to Tavily. Check data center DNS, certificates, and internet access."],
  "WEB_SEARCH_PROVIDER_FAILED": ["Tavily 服务返回异常，请稍后重试。", "Tavily returned an error. Try again later."],
  "WEB_SEARCH_INVALID_RESPONSE": ["Tavily 返回了无效搜索结果。", "Tavily returned an invalid search response."],
  "WEB_SEARCH_CONFIGURATION_UNAVAILABLE": ["无法读取联网搜索配置，请检查平台配置服务。", "Cannot read web search configuration. Check the platform configuration service."],
  "WEB_SEARCH_INVALID_QUERY": ["搜索关键词不能为空。", "The search query must not be empty."],
  "CC_THE_PRIVATE_NETWORK_READ_IDENTITY_OR_VPC_IS_NOT_CONFIGURED_COMPLETE": [
    "私网读取身份或 VPC 尚未接入，请完成数据中心基础配置",
    "The private-network read identity or VPC is not configured. Complete the data center foundation settings."
  ],
  "CC_CANNOT_READ_PUBLISHING_CONFIGURATION": [
    "无法读取发布配置",
    "Cannot read publishing configuration."
  ],
  "CC_PUBLISHING_CONFIGURATION_CHANGED_OR_IS_BEING_APPLIED_REFRESH_AND_RETRY": [
    "发布配置已更新或正在执行，请刷新后重试",
    "Publishing configuration changed or is being applied. Refresh and retry."
  ],
  "CC_OPERATION_AUDIT_IS_UNAVAILABLE": [
    "操作审计不可用",
    "Operation audit is unavailable."
  ],
  "CC_CANNOT_RECORD_THE_NETWORK_CHECK": [
    "无法记录网络检查",
    "Cannot record the network check."
  ],
  "CC_CONFIGURATION_CHANGED_DURING_THE_CHECK": [
    "检查期间配置已更新",
    "Configuration changed during the check."
  ],
  "CC_CONFIGURATION_CHANGED_DURING_THE_CHECK_RUN_THE_CHECK_AGAIN": [
    "检查期间配置已更新，请重新检查",
    "Configuration changed during the check. Run the check again."
  ],
  "CC_PRIVATE_ENDPOINT_DNS_AND_TCP_CHECKS_PASSED_SQL_AUTHORIZATION_IS_VERIFIED": [
    "私网端点、DNS 与 TCP 检查通过；SQL 授权在应用发布前验证",
    "Private endpoint, DNS, and TCP checks passed; SQL authorization is verified before application publishing"
  ],
  "CC_PRIVATE_NETWORK_CHECKS_FAILED": [
    "私网网络检查未通过",
    "Private network checks failed."
  ],
  "CC_CANNOT_SAVE_NETWORK_CHECK_RESULTS": [
    "无法保存网络检查结果",
    "Cannot save network check results."
  ],
  "CC_PUBLISHING_CREDENTIAL_MANAGEMENT_IS_NOT_CONNECTED": [
    "发布凭据管理尚未接入",
    "Publishing credential management is not connected."
  ],
  "CC_TIDB_CLOUD_CREDENTIALS_SAVED_THEY_ARE_VALIDATED_AND_ACTIVATED_DURING_INSTALLATION": [
    "TiDB Cloud 凭据已保存；安装或应用时验证并生效",
    "TiDB Cloud credentials saved; they are validated and activated during installation or apply"
  ],
  "CC_AN_OPERATION_REASON_IS_REQUIRED_TO_SAVE_PUBLISHING_CREDENTIALS": [
    "保存发布凭据必须填写操作原因",
    "An operation reason is required to save publishing credentials."
  ],
  "CC_THE_CREDENTIAL_CHANGE_WAS_REJECTED": [
    "凭据变更被拒绝",
    "The credential change was rejected."
  ],
  "CC_PAGINATION_PARAMETERS_ARE_INVALID": [
    "分页参数无效",
    "Pagination parameters are invalid."
  ],
  "CC_PAGINATION_OR_SEARCH_PARAMETERS_ARE_INVALID": [
    "分页或搜索参数无效",
    "Pagination or search parameters are invalid."
  ],
  "CC_THE_APPLICATION_PUBLISHING_MANAGEMENT_CONNECTION_IS_NOT_CONFIGURED": [
    "应用发布管理连接尚未配置",
    "The application publishing management connection is not configured."
  ],
  "CC_APPLICATIONS_REMAIN_INSTALLED_UNINSTALL_ALL_CURRENT_APPLICATION_VERSIONS_BEFORE_CHANGING_THE": [
    "当前仍有未卸载的应用，请先卸载全部当前应用版本再修改命名空间",
    "Applications remain installed. Uninstall all current application versions before changing the namespace."
  ],
  "CC_THE_PUBLISHING_GATEWAY_DID_NOT_COMPLETE_THE_REQUEST_CHECK_CONFIGURATION_PERMISSIONS": [
    "应用发布网关未完成请求，请核对配置、权限或最新状态",
    "The publishing gateway did not complete the request. Check configuration, permissions, and current state."
  ],
  "CC_ENTER_AN_OPERATION_REASON_OF_AT_MOST_512_CHARACTERS": [
    "请填写不超过 512 字的操作原因",
    "Enter an operation reason of at most 512 characters."
  ],
  "CC_READ_THE_CURRENT_CONFIGURATION_REVISION_FIRST": [
    "请先读取当前配置版本",
    "Read the current configuration revision first."
  ],
  "CC_CANNOT_CREATE_THE_OPERATION_AUDIT_RECORD": [
    "无法创建操作审计",
    "Cannot create the operation audit record."
  ],
  "CC_THE_GATEWAY_PERSISTED_THE_PUBLISHING_CONFIGURATION_IT_APPLIES_TO_NEW_PUBLISHING": [
    "发布配置已由 Gateway 持久化，将作用于新发布任务",
    "The gateway persisted the publishing configuration; it applies to new publishing operations"
  ],
  "CC_CONFIGURATION_SAVED_AUDIT_RECONCILIATION_WILL_CONTINUE_ON_REFRESH": [
    "配置已保存，审计将在刷新时继续核对",
    "Configuration saved; audit reconciliation will continue on refresh"
  ],
  "CC_DATABASE_DELETION_CONFIRMATION_MISMATCH": ["数据库归属或确认名称已变化，请刷新应用详情后重试", "Database ownership or confirmation has changed. Refresh application details and try again."],
  "CC_DATABASE_DELETION_CONFIRMATION_REQUIRED": ["请输入应用对应的完整数据库名以确认删除", "Type the complete application database name to confirm deletion."],
  "CC_REFRESH_THE_APPLICATION_STATE_BEFORE_PROCEEDING": [
    "请刷新应用状态后操作",
    "Refresh the application state before proceeding."
  ],
  "CC_THE_GATEWAY_REJECTED_THE_REQUEST": [
    "Gateway 拒绝了请求",
    "The gateway rejected the request."
  ],
  "CC_FAILED_TO_READ_AUDIT_RECORDS": [
    "读取审计失败",
    "Failed to read audit records."
  ],
  "CC_THE_GATEWAY_PERSISTED_THE_CONFIGURATION": [
    "Gateway 已持久化配置",
    "The gateway persisted the configuration"
  ],
  "CC_THIS_GATEWAY_UNINSTALL_ATTEMPT_FAILED_A_RETRY_WAS_STARTED": [
    "Gateway 本次卸载失败，后续已发起重试",
    "This gateway uninstall attempt failed; a retry was started"
  ],
  "CC_APPLICATION_UNINSTALLED_PERSISTENT_DATABASE_RETAINED": [
    "应用已卸载，持久数据库保留",
    "Application uninstalled; persistent database retained"
  ],
  "CC_THE_GATEWAY_UNINSTALL_DID_NOT_COMPLETE": [
    "Gateway 卸载未完成",
    "The gateway uninstall did not complete."
  ],
  "CC_THE_PUBLISHING_INSTALLER_IS_NOT_CONFIGURED_COMPLETE_DATA_CENTER_INITIALIZATION": [
    "发布组件安装器尚未配置，请完成数据中心初始化",
    "The publishing installer is not configured. Complete data center initialization."
  ],
  "CC_DRAFT_WAS_NOT_SAVED": [
    "草稿未保存",
    "Draft was not saved."
  ],
  "CC_DRAFT_SAVED_IT_HAS_NOT_BEEN_APPLIED_TO_THE_RUNTIME": [
    "已保存草稿，尚未应用到运行环境",
    "Draft saved; it has not been applied to the runtime"
  ],
  "PUBLISH_SETUP_NAMESPACE_SCOPE": [
    "草稿命名空间范围",
    "Draft namespace scope"
  ],
  "PUBLISH_SETUP_INSTALLER": [
    "发布安装器执行通道",
    "Publishing installer execution channel"
  ],
  "PUBLISH_SETUP_IMAGE_DIGESTS": [
    "安装器与网关镜像 digest",
    "Installer and gateway image digests"
  ],
  "PUBLISH_SETUP_TLS_ISSUER": [
    "网关内部 TLS issuer",
    "Gateway internal TLS issuer"
  ],
  "PUBLISH_SETUP_AWS_REGION": [
    "AWS 区域",
    "AWS region"
  ],
  "PUBLISH_SETUP_CREDENTIAL_REFERENCES": [
    "发布凭据引用；内容与权限在安装前核验",
    "Publishing credential references; contents and permissions are verified before installation"
  ],
  "PUBLISH_CREDENTIAL_STORE_UNAVAILABLE": [
    "发布凭据存储尚未接入，请检查固定 Secret 及其限定读写权限",
    "The publishing credential store is not connected. Check the designated Secret and its scoped read/write permissions."
  ],
  "CC_APPLICATION_PUBLISHING_MANAGEMENT_IS_NOT_ENABLED_IN_THIS_DATA_CENTER": [
    "此数据中心未启用应用发布管理连接",
    "Application publishing management is not enabled in this data center."
  ],
  "CC_DEDICATED_PUBLISHING_CONTROL_DATABASE": [
    "发布服务独立控制库",
    "Dedicated publishing control database"
  ],
  "CC_PUBLISHING_EXECUTION_MANAGEMENT_AND_ENCRYPTION_CREDENTIALS": [
    "发布执行、管理及加密凭据",
    "Publishing execution, management, and encryption credentials"
  ],
  "CC_GATEWAY_INTERNAL_TLS_TRUST_ROOT": [
    "网关内部 TLS 信任根",
    "Gateway internal TLS trust root"
  ],
  "CC_TIDB_CLOUD_API_CREDENTIALS_VALIDITY_IS_CHECKED_BEFORE_INSTALLATION": [
    "TiDB Cloud API 凭据；有效性在安装前验证",
    "TiDB Cloud API credentials; validity is checked before installation"
  ],
  "PUBLISH_SHARED_CLUSTER_CREDENTIAL_MATCH": ["共享实例 ID 与受限凭据绑定一致", "The shared cluster ID matches its stored credential binding."],
  "PUBLISH_SHARED_CLUSTER_ID_INVALID": ["共享 TiDB 实例 ID 无效", "The shared TiDB cluster ID is invalid."],
  "CC_ENTER_BOTH_A_VALID_TIDB_CLOUD_API_PUBLIC_KEY_AND_PRIVATE": [
    "请填写完整有效的 TiDB Cloud API 公钥和私钥，或共享实例 ID 和密码",
    "Enter a complete valid TiDB Cloud API key pair, or a shared cluster ID and password."
  ],
  "CC_CLUSTER_CONNECTION_IS_HEALTHY": [
    "集群连接正常",
    "Cluster connection is healthy"
  ],
  "CC_THE_NAMESPACE_WILL_BE_CREATED_DURING_INSTALLATION": [
    "命名空间将在安装时创建",
    "The namespace will be created during installation"
  ],
  "CC_THE_NAMESPACE_IS_MANAGED_BY_THIS_PUBLISHING_COMPONENT": [
    "已纳管命名空间",
    "The namespace is managed by this publishing component"
  ],
  "CC_THE_NAMESPACE_ALREADY_EXISTS_AND_IS_NOT_OWNED_BY_THIS_PUBLISHING": [
    "命名空间已存在，且不属于当前发布组件",
    "The namespace already exists and is not owned by this publishing component"
  ],
  "CC_CREDENTIAL_REFERENCES_ARE_SPECIFIED_THE_INSTALLER_VERIFIES_THEIR_CONTENTS_BEFORE_INSTALLATION": [
    "凭据引用已指定，实际内容将在安装前由执行器校验",
    "Credential references are specified; the installer verifies their contents before installation"
  ],
  "CC_THE_PACTURE_PUBLISHING_ENTRY_WILL_BE_CONNECTED_AFTER_SUCCESSFUL_INSTALLATION": [
    "安装成功后接入 Pacture 发布入口",
    "The Pacture publishing entry will be connected after successful installation"
  ],
  "CC_THE_PACTURE_PUBLISHING_ENTRY_BINDING_MATCHES": [
    "Pacture 发布入口绑定一致",
    "The Pacture publishing entry binding matches"
  ],
  "CC_THE_SERVICE_ALIAS_IS_OCCUPIED_OR_POINTS_TO_ANOTHER_GATEWAY_REVIEW": [
    "服务别名已被占用或指向其他网关，须先核对迁移",
    "The service alias is occupied or points to another gateway. Review the migration first."
  ],
  "CC_THE_PUBLISHING_GATEWAY_SERVICE_ALIAS_IS_OWNED_BY_ANOTHER_COMPONENT": [
    "发布网关服务别名已由其他组件占用",
    "The publishing gateway service alias is owned by another component."
  ],
  "CC_THE_DATA_CENTER_S_PRIVATE_NETWORK_READ_IDENTITY_IS_NOT_CONFIGURED": [
    "数据中心私网读取身份尚未接入",
    "The data center's private-network read identity is not configured."
  ],
  "CC_PRIVATE_ENDPOINT_DNS_AND_TCP_CHECKS_SQL_AUTHORIZATION_IS_VERIFIED_BEFORE": [
    "私网端点、DNS 与 TCP 检查；SQL 授权在应用发布前验证",
    "Private endpoint, DNS, and TCP checks; SQL authorization is verified before application publishing"
  ],
  "CC_THE_ENDPOINT_IS_AVAILABLE_AND_PRIVATE_DNS_IS_ENABLED": [
    "端点可用且已启用 Private DNS",
    "The endpoint is available and Private DNS is enabled"
  ],
  "CC_PRIVATE_DNS_MUST_RESOLVE_TO_THE_SELECTED_ENDPOINT_S_NETWORK_INTERFACES": [
    "私网 DNS 必须解析到所选端点的网卡",
    "Private DNS must resolve to the selected endpoint's network interfaces"
  ],
  "CC_VERIFY_PRIVATE_SQL_PORT_4000_CONNECTIVITY_FROM_CONTROL_CENTER": [
    "从控制中心验证私网 SQL 4000 端口可达",
    "Verify private SQL port 4000 connectivity from Control Center"
  ],
  "CC_THE_ENDPOINT_HAS_NO_SUPPORTED_TIDB_SHARED_PRIVATE_NETWORK_DOMAIN": [
    "端点没有受支持的 TiDB 共享私网域名",
    "The endpoint has no supported TiDB shared private-network domain."
  ],
  "CC_PRIVATE_NETWORK_READS_REQUIRE_A_WORKLOAD_IDENTITY": [
    "私网读取必须使用工作负载身份",
    "Private-network reads require a workload identity."
  ],
  "CC_THE_TIDB_PRIVATE_NETWORK_READ_IDENTITY_IS_NOT_CONFIGURED": [
    "TiDB 私网读取身份未配置",
    "The TiDB private-network read identity is not configured."
  ],
  "CC_THE_INTERFACE_ENDPOINT_DOES_NOT_BELONG_TO_THIS_DATA_CENTER": [
    "端点不属于当前数据中心的接口端点",
    "The interface endpoint does not belong to this data center."
  ],
  "CC_CANNOT_READ_THE_ENDPOINT_SERVICE_CHECK_THE_NETWORK_READ_ONLY_IDENTITY": [
    "无法读取端点服务，请检查网络只读身份",
    "Cannot read the endpoint service. Check the network read-only identity."
  ],
  "CC_THE_ENDPOINT_SERVICE_DOES_NOT_MATCH": [
    "端点服务不匹配",
    "The endpoint service does not match."
  ],
  "CC_CANNOT_LIST_TIDB_PRIVATE_ENDPOINTS_CHECK_THE_DATA_CENTER_S_NETWORK": [
    "无法列出 TiDB 私网端点，请检查数据中心网络读取身份",
    "Cannot list TiDB private endpoints. Check the data center's network read identity."
  ],
  "CC_THE_ENDPOINT_COUNT_EXCEEDS_THE_INSPECTION_LIMIT_NARROW_THE_DATA_CENTER": [
    "端点数量超出检查范围，请先缩小数据中心网络范围",
    "The endpoint count exceeds the inspection limit. Narrow the data center network scope first."
  ],
  "CC_SELECT_A_VALID_TIDB_PRIVATE_ENDPOINT": [
    "请选择有效的 TiDB 私网端点",
    "Select a valid TiDB private endpoint."
  ],
  "CC_CANNOT_READ_THE_SELECTED_ENDPOINT_CHECK_THE_NETWORK_READ_IDENTITY_AND": [
    "无法读取指定端点，请检查网络读取身份和端点状态",
    "Cannot read the selected endpoint. Check the network read identity and endpoint state."
  ],
  "CC_THE_PRIVATE_ENDPOINT_S_NETWORK_INTERFACE_INFORMATION_IS_INCOMPLETE": [
    "私网端点网卡信息不完整",
    "The private endpoint's network interface information is incomplete."
  ],
  "CC_CANNOT_VERIFY_THE_ENDPOINT_S_NETWORK_INTERFACES": [
    "无法核验端点网卡",
    "Cannot verify the endpoint's network interfaces."
  ],
  "CC_THE_ENDPOINT_S_NETWORK_INTERFACE_SET_DOES_NOT_MATCH": [
    "端点网卡集合不一致",
    "The endpoint's network interface set does not match."
  ],
  "CC_THE_ENDPOINT_S_NETWORK_INTERFACES_ARE_OUTSIDE_THIS_DATA_CENTER_S": [
    "端点网卡不属于本数据中心的私网",
    "The endpoint's network interfaces are outside this data center's private network."
  ],
  "CC_THE_OPERATION_PARAMETERS_OR_CHANGE_REASON_ARE_INVALID": [
    "操作参数或变更原因无效",
    "The operation parameters or change reason are invalid."
  ],
  "CC_ENVIRONMENT_CHECKS_FAILED": [
    "环境检查未通过",
    "Environment checks failed."
  ],
  "CC_PUBLISHING_CONFIGURATION_CHANGED_OR_AN_OPERATION_IS_IN_PROGRESS_REFRESH_AND": [
    "发布配置已更新或有操作正在执行，请刷新后重试",
    "Publishing configuration changed or an operation is in progress. Refresh and retry."
  ],
  "CC_THE_PUBLISHING_OPERATION_WAS_NOT_FOUND": [
    "发布组件操作不存在",
    "The publishing operation was not found."
  ],
  "CC_THE_PUBLISHING_INSTALLER_S_BASE_CONFIGURATION_IS_INCOMPLETE": [
    "发布安装器基础配置不完整",
    "The publishing installer's base configuration is incomplete."
  ],
  "CC_PUBLISHING_IMAGES_MUST_BE_PINNED_TO_SHA_256_DIGESTS": [
    "发布镜像必须固定到 sha256 digest",
    "Publishing images must be pinned to SHA-256 digests."
  ],
  "CC_CONFIGURE_THE_ALLOWED_NAMESPACE_PREFIXES": [
    "必须配置允许创建的命名空间前缀",
    "Configure the allowed namespace prefixes."
  ],
  "CC_THE_PUBLISHING_NAMESPACE_PREFIX_IS_INVALID": [
    "发布命名空间前缀无效",
    "The publishing namespace prefix is invalid."
  ],
  "CC_THE_TIDB_PRIVATE_ENDPOINT_ID_IS_INVALID": [
    "TiDB 私网端点 ID 无效",
    "The TiDB private endpoint ID is invalid."
  ],
  "CC_SELECT_A_TIDB_PRIVATE_ENDPOINT_IN_THIS_DATA_CENTER_S_REGION": [
    "请选择当前数据中心区域内的 TiDB 私网端点，并确认 VPC 基础配置",
    "Select a TiDB private endpoint in this data center's region and verify the VPC configuration."
  ],
  "CC_THE_NAMESPACE_IS_OUTSIDE_THE_ALLOWED_SCOPE_OR_ITS_NAME_IS": [
    "命名空间不在允许范围内，或名称无效",
    "The namespace is outside the allowed scope or its name is invalid."
  ],
  "CC_THE_GATEWAY_AND_APPLICATIONS_MUST_USE_SEPARATE_NAMESPACES": [
    "网关与应用必须使用不同命名空间",
    "The gateway and applications must use separate namespaces."
  ],
  "CC_THIS_VERSION_OF_THE_PUBLISHING_GATEWAY_SUPPORTS_ONE_REPLICA": [
    "当前版本的发布网关仅支持一个副本",
    "This version of the publishing gateway supports one replica."
  ],
  "CC_THE_CPU_OR_MEMORY_SPECIFICATION_IS_OUTSIDE_THE_ALLOWED_RANGE": [
    "CPU 或内存规格不在允许范围内",
    "The CPU or memory specification is outside the allowed range."
  ],
  "CC_SELECT_AT_MOST_100_NODES": [
    "最多选择 100 个节点",
    "Select at most 100 nodes."
  ],
  "CC_THE_NODE_SELECTION_IS_INVALID_OR_CONTAINS_DUPLICATES": [
    "节点选择无效或重复",
    "The node selection is invalid or contains duplicates."
  ],
  "CC_ENTER_THE_PUBLISHING_DOMAIN_INGRESS_TYPE_AND_TIDB_REGION_FIRST": [
    "请先填写发布域名、入口类型和 TiDB 区域",
    "Enter the publishing domain, ingress type, and TiDB region first."
  ],
  "CC_A_CERTIFICATE_REFERENCE_IS_REQUIRED_TO_ENABLE_HTTPS": [
    "启用 HTTPS 必须配置证书引用",
    "A certificate reference is required to enable HTTPS."
  ],
  "CC_ONLY_INTERNATIONAL_TLS_IS_CURRENTLY_SUPPORTED": [
    "当前仅支持 international TLS",
    "Only international TLS is currently supported."
  ],
  "CC_THE_TIDB_MONTHLY_SPENDING_LIMIT_MUST_BE_BETWEEN_0_AND_1000000": [
    "TiDB 月度支出上限必须在 0 到 1000000 之间",
    "The TiDB monthly spending limit must be between 0 and 1000000."
  ],
  "CC_THE_TIDB_REGION_OR_PROJECT_REFERENCE_IS_INVALID": [
    "TiDB 区域或项目引用无效",
    "The TiDB region or project reference is invalid."
  ],
  "CC_THE_INGRESS_TYPE_NAME_IS_INVALID": [
    "入口类型名称无效",
    "The ingress type name is invalid."
  ],
  "CC_THE_CERTIFICATE_REFERENCE_DOES_NOT_MATCH_THE_INGRESS_TYPE": [
    "证书引用与入口类型不匹配",
    "The certificate reference does not match the ingress type."
  ],
  "CC_SELECT_A_NODE_POOL_THAT_EXISTS_IN_THE_CLUSTER": [
    "请选择集群中存在的节点池",
    "Select a node pool that exists in the cluster."
  ],
  "CC_NAMESPACES_CANNOT_BE_CHANGED_DIRECTLY_AFTER_THE_INSTALLATION_BINDING_IS_ESTABLISHED": [
    "安装绑定建立后不能直接修改命名空间",
    "Namespaces cannot be changed directly after the installation binding is established."
  ],
  "CC_INSTALL_THE_PUBLISHING_SERVICE_FIRST": [
    "请先安装发布服务",
    "Install the publishing service first."
  ],
  "CC_THE_EXECUTION_JOB_IS_MISSING_CHECK_THE_HELM_STATE_BEFORE_RECOVERY": [
    "执行任务已丢失，请人工核对 Helm 状态后恢复",
    "The execution job is missing. Check the Helm state before recovery."
  ],
  "CC_WAITING_TO_READ_THE_EXISTING_EXECUTION_JOB": [
    "等待读取已有执行任务",
    "Waiting to read the existing execution job"
  ],
  "CC_THE_PUBLISHING_INSTALLER_IDENTITY_LACKS_THE_REQUIRED_PERMISSIONS_CHECK_INFRASTRUCTURE_ACCESS": [
    "发布安装器身份未获得所需权限，请检查基础设施接入",
    "The publishing installer identity lacks the required permissions. Check infrastructure access."
  ],
  "CC_THE_EXECUTION_JOB_IDENTITY_DOES_NOT_MATCH_AUTOMATIC_RECOVERY_HAS_STOPPED": [
    "执行任务身份不一致，已停止自动恢复",
    "The execution job identity does not match. Automatic recovery has stopped."
  ],
  "CC_THE_EXECUTION_JOB_DOES_NOT_MATCH_THE_SUBMITTED_INTENT_AUTOMATIC_RECOVERY": [
    "执行任务内容与已提交意图不一致，已停止自动恢复",
    "The execution job does not match the submitted intent. Automatic recovery has stopped."
  ],
  "CC_EXECUTION_COMPLETED": [
    "执行完成",
    "Execution completed"
  ],
  "CC_EXECUTION_FAILED_REVIEW_THE_INSTALLER_S_REDACTED_LOGS_RESOURCES_ARE_RETAINED": [
    "执行失败，请查看安装任务的脱敏日志；已保留资源便于恢复",
    "Execution failed. Review the installer's redacted logs; resources are retained for recovery."
  ],
  "CC_VALIDATING_DEPENDENCIES_AND_EXECUTING_THE_PUBLISHING_OPERATION": [
    "正在校验依赖并执行发布组件操作",
    "Validating dependencies and executing the publishing operation"
  ],
  "CC_THE_CONFIGURATION_REVISION_CHANGED_REFRESH_AND_RETRY": [
    "配置版本已变化，请刷新后重试",
    "The configuration revision changed. Refresh and retry."
  ],
  "CC_THIS_CONFIGURATION_IS_IN_USE_COMPLETE_OR_RESUME_THE_EXISTING_DEPLOYMENT": [
    "部署正在使用此配置，请先完成或接续原部署",
    "This configuration is in use. Complete or resume the existing deployment first."
  ],
  "CC_MAINTENANCE_UPGRADES_ARE_NOT_ENABLED_OR_A_DEDICATED_DEPLOYMENT_CREDENTIAL_HAS": [
    "维护升级尚未启用或独立部署凭据尚未生成",
    "Maintenance upgrades are not enabled or a dedicated deployment credential has not been generated."
  ],
  "CC_UPGRADE_CONFIGURATION_STORAGE_IS_UNAVAILABLE_CHECK_DATA_CENTER_INITIALIZATION_AND_SCOPED": [
    "升级配置存储不可用，请检查数据中心初始化和限定 Secret 权限",
    "Upgrade configuration storage is unavailable. Check data center initialization and scoped Secret permissions."
  ],
  "CC_THE_UPGRADE_CONFIGURATION_OR_DEPLOYMENT_REQUEST_IS_INVALID": [
    "升级配置或部署请求无效",
    "The upgrade configuration or deployment request is invalid."
  ],
  "UPGRADE_CHECK_STORAGE": [
    "配置存储及固定 Secret 读写权限",
    "Configuration storage and read/write permissions for the designated Secret"
  ],
  "UPGRADE_CHECK_CREDENTIAL": [
    "独立部署凭据",
    "Dedicated deployment credential"
  ],
  "UPGRADE_CHECK_COORDINATOR": [
    "维护协调组件连接与协议",
    "Maintenance coordinator connection and protocol"
  ],
  "UPGRADE_CHECK_IDLE": [
    "没有在途部署或维护操作",
    "No deployment or maintenance operation is in progress"
  ],
  "UPGRADE_CHECK_ENABLED": [
    "维护升级已启用",
    "Maintenance upgrades are enabled"
  ],
  "UPGRADE_CHECK_EXECUTOR_RECEIPT": [
    "部署端已读取当前配置版本（不代表发布成功）",
    "The deployment executor has read this configuration revision; this does not confirm deployment success"
  ],
  "CC_UPGRADE_CONFIGURATION_SAVED_THE_DEPLOYMENT_EXECUTOR_S_RECEIPT_IS_SHOWN_SEPARATELY": [
    "升级配置已保存到部署通道；部署端回执单独展示",
    "Upgrade configuration saved; the deployment executor's receipt is shown separately"
  ],
  "CC_UPGRADE_CONFIGURATION_WAS_NOT_CHANGED": [
    "升级配置未变更",
    "Upgrade configuration was not changed"
  ],
  "CC_THE_DEPLOYMENT_CONFIGURATION_COMMAND_WAS_NOT_EXECUTED": [
    "部署配置命令未执行",
    "The deployment configuration command was not executed"
  ],
  "PUBLISH_CHECK_NODE_CAPACITY": [
    "匹配 {count} 个可调度节点；实际余量以调度器为准",
    "{count} schedulable nodes match; available capacity is determined by the scheduler"
  ],
  "OPERATION_SUCCEEDED": [
    "操作 {action} 已完成",
    "Operation {action} completed"
  ],
  "OPERATION_PENDING": [
    "操作 {action} 正在处理",
    "Operation {action} is pending"
  ],
  "OPERATION_FAILED": [
    "操作 {action} 未完成",
    "Operation {action} failed"
  ],
  "DIAGNOSTIC_UNAVAILABLE": [
    "无法读取诊断结果",
    "Diagnostic information is unavailable"
  ],
  "PUBLISH_LIFECYCLE_FAILED": [
    "发布操作未完成，请核对组件状态",
    "Publishing operation failed; check the component state"
  ],
  "PRIVATE_NETWORK_UNAVAILABLE": [
    "私网检查不可用",
    "Private network inspection is unavailable"
  ],
  "PRIVATE_NETWORK_CHECK_FAILED": [
    "私网检查未通过",
    "Private network checks failed"
  ]
};
